import { LoadingSpinner } from '@/components/UI/Common/Admin/LoadingSpinner';
import { PageLayout } from '@/components/UI/Layouts/Admin/PageLayout';
import { ROUTES } from '@/config/routes';
import { useDeleteOne, useGetOne, useUpdateOne } from '@/queries/admin';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { getBackUrl } from '@/utils/helpers';
import { Form, type FormData } from './Form';

export const Edit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isDeleting, setIsDeleting] = useState(false);
  const { data: chat } = useGetOne('chats', id!, { enabled: Boolean(id) && !isDeleting });
  const { mutateAsync: updateChat } = useUpdateOne('chats');
  const { mutateAsync: deleteChat } = useDeleteOne('chats');
  const [formData, setFormData] = useState<Partial<FormData> | null>(null);

  useEffect(() => {
    if (!chat) return;

    const normalizedChat: Partial<FormData> = {
      ...chat,
      userId: chat.userId ?? '',
      userGroups: chat.userGroups?.map((group) => group.id) ?? [],
      chatGroups: chat.chatGroups?.map((group) => group.id) ?? [],
      avatar: {
        url: chat.upload?.path ? `${getBackUrl()}/uploads/${chat.upload.path}` : '',
        rawFile: null,
      },
    };
    setFormData(normalizedChat);
  }, [chat]);

  const onSubmit = async (data: FormData) => {
    try {
      await updateChat({
        id: id!,
        data: {
          ...data,
          userId: data.type === 'public' ? null : data.userId || null,
        },
      });
      toast.success('Чат успешно обновлён');
      navigate(ROUTES.ADMIN.CHATS);
    } catch (error) {
      console.error('Error updating chat:', error);
      toast.error('Произошла ошибка при обновлении чата');
    }
  };

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      await deleteChat({ id: id! });
      toast.success('Чат успешно удалён');
      navigate(ROUTES.ADMIN.CHATS);
    } catch (error) {
      setIsDeleting(false);
      console.error('Error deleting chat:', error);
      toast.error('Произошла ошибка при удалении чата');
    }
  };

  if (!formData) return <LoadingSpinner className="mt-6" text="Загрузка..." />;

  return (
    <PageLayout
      breadcrumbs={[
        {
          label: 'Чаты',
          href: ROUTES.ADMIN.CHATS,
        },
        {
          label: 'Редактирование',
          href: '',
        },
      ]}
    >
      <Form onDelete={handleDelete} onSubmit={onSubmit} formData={formData} />
    </PageLayout>
  );
};
